// Modal: editar datos básicos de un prospecto existente
import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import UbicacionPicker from "./UbicacionPicker";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const ProspeccionEditarModal = ({ prospecto, onClose, onSaved }) => {
  const [submitting, setSubmitting] = useState(false);

  // Catálogos
  const [segmentos,  setSegmentos]  = useState([]);
  const [industrias, setIndustrias] = useState([]);
  const [origenes,   setOrigenes]   = useState([]);

  const [form, setForm] = useState({
    empresa:             prospecto.empresa             || "",
    segmento:            prospecto.segmento            || prospecto.segmento_prospeccion || "",
    industria:           prospecto.industria           || "",
    pais:                prospecto.pais                || "Argentina",
    provincia:           prospecto.provincia           || "",
    ciudad:              prospecto.ciudad              || "",
    calle:               prospecto.calle               || "",
    numero:              prospecto.numero              || "",
    sitio_web:           prospecto.sitio_web           || "",
    instagram:           prospecto.instagram           || "",
    linkedin:            prospecto.linkedin            || "",
    origen:              prospecto.origen              || "",
    origen_detalle:      prospecto.origen_detalle      || "",
    senal_calificacion:  prospecto.senal_calificacion  || "",
    notas:               prospecto.notas               || "",
  });

  useEffect(() => {
    axios.get(`${BASE}/buscar_segmentos.php`).then((r) => {
      if (Array.isArray(r.data)) setSegmentos(r.data);
    }).catch(() => {});
    axios.get(`${BASE}/buscar_industrias.php`).then((r) => {
      if (Array.isArray(r.data)) setIndustrias(r.data);
    }).catch(() => {});
    axios.get(`${BASE}/buscar_origenes_prospeccion.php`).then((r) => {
      if (Array.isArray(r.data)) setOrigenes(r.data);
    }).catch(() => {});
  }, []);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.empresa.trim()) return toast.error("La empresa es obligatoria");

    setSubmitting(true);
    try {
      const fd = new FormData();
      fd.append("id", prospecto.id);
      Object.entries(form).forEach(([k, v]) => fd.append(k, v ?? ""));

      const r = await axios.post(`${BASE}/prospectos_guardar.php`, fd);
      if (r.data?.success) {
        toast.success("Datos actualizados");
        if (onSaved) onSaved();
      } else {
        toast.error(r.data?.mensaje || "Error al guardar");
        setSubmitting(false);
      }
    } catch {
      toast.error("Error de conexión");
      setSubmitting(false);
    }
  };

  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={(e) => e.stopPropagation()}>
        <h2 style={{ margin: "0 0 18px", fontSize: 20, fontWeight: 700, color: "#9f0059" }}>
          ✎ Editar datos del prospecto
        </h2>

        <form onSubmit={handleSubmit}>
          <Field label="Empresa *">
            <input style={inp} value={form.empresa} onChange={set("empresa")} autoFocus />
          </Field>

          <Row>
            <Field label="Segmento">
              <select style={inp} value={form.segmento} onChange={set("segmento")}>
                <option value="">Seleccionar…</option>
                {segmentos.map((s) => <option key={s.id} value={s.nombre}>{s.nombre}</option>)}
              </select>
            </Field>
            <Field label="Industria">
              <select style={inp} value={form.industria} onChange={set("industria")}>
                <option value="">Seleccionar…</option>
                {industrias.map((i) => <option key={i.id} value={i.nombre}>{i.nombre}</option>)}
              </select>
            </Field>
          </Row>

          <div style={{ marginBottom: 12 }}>
            <label style={fieldLabel}>Ubicación</label>
            <UbicacionPicker
              value={{
                pais:     form.pais,
                provincia: form.provincia,
                ciudad:   form.ciudad,
                calle:    form.calle,
                numero:   form.numero,
              }}
              onChange={(v) => setForm((f) => ({ ...f, ...v }))}
            />
          </div>

          <Field label="Sitio web">
            <input style={inp} value={form.sitio_web} onChange={set("sitio_web")} placeholder="empresa.com.ar" />
          </Field>

          <Row>
            <Field label="Instagram">
              <input style={inp} value={form.instagram} onChange={set("instagram")} placeholder="@empresa o URL" />
            </Field>
            <Field label="LinkedIn empresa">
              <input style={inp} value={form.linkedin} onChange={set("linkedin")} placeholder="linkedin.com/company/..." />
            </Field>
          </Row>

          <Row>
            <Field label="Origen">
              <select style={inp} value={form.origen} onChange={set("origen")}>
                <option value="">Seleccionar…</option>
                {origenes.map((o) => <option key={o.id} value={o.nombre}>{o.nombre}</option>)}
              </select>
            </Field>
            <Field label="Detalle del origen">
              <input style={inp} value={form.origen_detalle} onChange={set("origen_detalle")} />
            </Field>
          </Row>

          <Field label="Señal de calificación">
            <textarea
              style={{ ...inp, minHeight: 60, fontFamily: "inherit", resize: "vertical" }}
              value={form.senal_calificacion}
              onChange={set("senal_calificacion")}
              placeholder="¿Por qué creés que califica?"
            />
          </Field>

          <Field label="Notas">
            <textarea
              style={{ ...inp, minHeight: 60, fontFamily: "inherit", resize: "vertical" }}
              value={form.notas}
              onChange={set("notas")}
            />
          </Field>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 24, paddingTop: 16, borderTop: "1.5px solid #f0e6ec" }}>
            <button type="button" onClick={onClose} style={btnSecondary} disabled={submitting}>Cancelar</button>
            <button type="submit" style={btnPrimary} disabled={submitting}>
              {submitting ? "Guardando…" : "Guardar cambios"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// ─── Styles ───────────────────────────────────────────────────────────────────
const overlay = {
  position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
  background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center",
  zIndex: 1000, padding: 20,
};
const modal = {
  background: "#fff", borderRadius: 14, padding: "26px 30px",
  maxWidth: 640, width: "100%", maxHeight: "90vh", overflowY: "auto",
  boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
};
const inp = {
  width: "100%", padding: "9px 12px",
  border: "1.5px solid #e0d6dc", borderRadius: 8,
  fontSize: 13, color: "#222", background: "#fafafa",
  outline: "none", boxSizing: "border-box", fontFamily: "inherit",
};
const btnPrimary = {
  padding: "10px 22px", background: "#9f0059", color: "#fff",
  border: "none", borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: "pointer",
};
const btnSecondary = {
  padding: "10px 22px", background: "#fff", color: "#666",
  border: "1.5px solid #e0d6dc", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer",
};
const fieldLabel = {
  display: "block", fontSize: 11, fontWeight: 700, color: "#888",
  textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 4,
};
const Field = ({ label, children }) => (
  <div style={{ marginBottom: 12 }}>
    <label style={fieldLabel}>{label}</label>
    {children}
  </div>
);
const Row = ({ children }) => (
  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>{children}</div>
);

export default ProspeccionEditarModal;
